import { mapState, mapActions } from "vuex";

export const authComputed = {
  ...mapState("auth", {
    user: (state) => state.user,
    domain: (state) => state.domain,
    domains: (state) => state.domains,
    MOH: (state) => state.MOH,
  }),
};

export const authMethods = mapActions("auth", [
  "login",
  "loginByOTP",
  "logout",
  "setDomain",
  "setDomains",
  "setMOH",
  "setFingerPrint",
]);

export const layoutComputed = {
  ...mapState("layout", {
    theme: (state) => state.theme,
  }),
};

export const layoutMethods = mapActions("layout", ["changeTheme"]);
